import { View } from 'backbone.marionette';
import { ContactUsModel } from '../../models';
import _ from 'lodash';
import { ErrorsModal } from '../../utils';
import { LocalStorage } from "../../utils/Storage";

export default class ContactUsCoreView extends View {
	get template() {
		throw new Error( "Need set template for child ContactUsCoreView class" );
	}

	get file_name() {
		return '';
	}

	get var_name() {
		return '';
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	ui() {
		return {
			contact_form: '.js-contact-form',
			submit_form:  '.js-send-contact-form'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'change @ui.contact_form': 'updateForm',
			'click @ui.submit_form':   'validateForm'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'contact:us:update:form:errors':  'showContactFormErrors',
			'contact:us:update:form:success': 'sendContactUsSuccess',
			'contact:send:errors':            'showResponseError',
			'contact:send:success':           'showResponseSuccess'
		};
	}

	initialize() {
		this.model = new ContactUsModel({
			contact_us_html: ''
		});

		this.init();
	}

	init() {
		const contact_us_html = _.result(window, 'EXPORTS.GLOBAL_DATA.contact_us', '');

		if (contact_us_html !== '') {
			return this.setAttributes();
		}

		window.EXPORTS = {
			GLOBAL_DATA: {}
		};

		const header_info_script = document.createElement('script'),
			ABSPATH = process.env.ABSPATH,
			version = `?v=${LocalStorage.get('web_version') || Date.now()}`,
			path = `${ABSPATH}cms/contact_us/${this.file_name}.js${version}`
		;

		header_info_script.onload = this.setAttributes.bind(this);

		header_info_script.setAttribute('src', path);

		document.head.appendChild(header_info_script);

		return this;
	}

	setAttributes() {
		const contact_us_html = _.result(window.EXPORTS.GLOBAL_DATA, this.var_name, '');

		this.model.set({
			contact_us_html
		});

		this.render();
	}

	validateForm() {
		this.model.validateForm();
		return this;
	}

	showContactFormErrors( errors ) {
		_.each( errors, ( item, name ) => {
			$( '.error-' + name ).text( item[ 0 ] ).show();
		} );
		return this;
	}

	hiddenContactFormError() {
		$('.error-message').hide();
		return this;
	}

	sendContactUsSuccess() {
		this.model.sendContactData();
		return this;
	}

	updateSendButton() {
		let button = this.getUI( 'submit_form' );
		button.removeClass( 'tertiary-btn' )
			.addClass( 'primary-btn' )
			.text( 'SUBMIT' );

		return this;
	}

	updateForm() {
		let form      = this.getUI( 'contact_form' ),
			form_data = form.serializeArray(),
			data      = { 'errors': {} };

		_.each( form_data, function ( input ) {
			data[ input.name ] = input.value;
		} );
		this.model.set( data );
		this.updateSendButton()
			.hiddenContactFormError();
	}

	showResponseSuccess() {
		let button = this.getUI( 'submit_form' );
		button.removeClass( 'primary-btn' )
			.addClass( 'tertiary-btn' )
			.text( 'submitted' );

		this.clearForm();
	}

	clearForm() {
		let form = this.getUI( 'contact_form' );

		form
			.find('input, select, textarea')
			.not(':button, :submit, :reset, :hidden')
			.val('')
			.removeAttr('checked')
			.removeAttr('selected');

		this.model.clearData();

		return this;
	}

	showResponseError( errors ) {
		ErrorsModal.show( errors );
	}

}